import { Component } from '@angular/core';
import { FiDocumentTemplateItemViewBase } from './document-template-item-view-base';

@Component({
    selector: 'fi-document-template-item-view-advanced-text',
    template: `
        <fi-document-layout-item-advanced-text
            [item]="data.item"
            [templateLayoutHelper]="data.templateLayoutHelper"
            [disableEdit]="data.disableEdit"
        >
        </fi-document-layout-item-advanced-text>
    `,
    standalone: false,
})
export class FiDocumentTemplateItemViewAdvancedTextComponent extends FiDocumentTemplateItemViewBase {}
